import { render, staticRenderFns } from "./ResetRealityModal.vue?vue&type=template&id=5e466ec0&scoped=true"
import script from "./ResetRealityModal.vue?vue&type=script&lang=js"
export * from "./ResetRealityModal.vue?vue&type=script&lang=js"
import style0 from "./ResetRealityModal.vue?vue&type=style&index=0&id=5e466ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e466ec0",
  null
  
)

export default component.exports